module.exports = __webpack_public_path__ + "img/google-play-badge.151a2968.png";